import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

const cseTooltipArrowSize = css`8px`

export const cseTooltip = {
  backgroundColor: css`var(--cse-tooltip-background-color, ${csColorBackground.tooltip})`,
  borderRadius: css`var(--cse-tooltip-border-radius, ${csBorder.radiusMinimal})`,
  borderRadiusArrow: css`var(--cse-tooltip-border-radius-arrow, ${csBorder.radiusMinimal})`,
  color: css`var(--cse-tooltip-color, ${csColorText.white})`,
  paddingBlock: css`var(--cse-tooltip-padding-y, ${csSpacing.spacing04})`,
  paddingInline: css`var(--cse-tooltip-padding-x, ${csSpacing.spacing04})`,
}

export const style: CSSResult = css`
  :host {
    position: relative;
  }

  .tooltip {
    --cse-text-color: ${cseTooltip.color};

    background: ${cseTooltip.backgroundColor};
    border-radius: ${cseTooltip.borderRadius};
    display: inline-block;
    padding-block: ${cseTooltip.paddingBlock};
    padding-inline: ${cseTooltip.paddingInline};
    position: relative;
    white-space: nowrap;
  }

  .tooltip-arrow {
    position: absolute;
    width: ${cseTooltipArrowSize};
    height: ${cseTooltipArrowSize};
    background-color: ${cseTooltip.backgroundColor};
    clip-path: polygon(0 0, 100% 0, 0 100%);
    border-top-left-radius: ${cseTooltip.borderRadiusArrow};
  }

  [current-placement="top"] .tooltip-arrow {
    bottom: calc(${cseTooltipArrowSize} / 2 * -1);
    left: calc(50% - ${cseTooltipArrowSize} / 2);
    transform: rotate(-135deg);
  }

  [current-placement="right"] .tooltip-arrow {
    top: calc(50% - ${cseTooltipArrowSize} / 2);
    left: calc(${cseTooltipArrowSize} / 2 * -1);
    transform: rotate(-45deg);
  }

  [current-placement="bottom"] .tooltip-arrow {
    left: calc(50% - ${cseTooltipArrowSize} / 2);
    top: calc(${cseTooltipArrowSize} / 2 * -1);
    transform: rotate(45deg);
  }

  [current-placement="left"] .tooltip-arrow {
    right: calc(${cseTooltipArrowSize} / 2 * -1);
    top: calc(50% - ${cseTooltipArrowSize} / 2);
    transform: rotate(135deg);
  }
`
